export type Notification = {
    read: boolean;
    entityLabel: string;
    actionType: string;
    actorName: string | null;
    key: string;
    id: number;
    redirectTo: RedirectTo;
    createdAt: string;
};

type RedirectTo = {
    pathname: string;
    hash?: string;
    search?: string;
};

export enum NotificationColumn {
    CONTENT = 'CONTENT',
    DATE = 'DATE',
}
